// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card_i9TI1","title":"Card_title_1-duG","container":"Card_container_3eNl0","footer":"Card_footer_2oT9i"};